
import React from "react";

// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";






// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";

import { connect } from 'react-redux';

import {resampleDistance,resampleDuration} from '../helperFunctions/Resample';
import {distanceList,durationList,distanceSum,durationSum,rollingDistance,filter_activities,rollingduration} from '../helperFunctions/analyticsFunctions'
import {metricDistance,metricDistanceAnalytics,metric} from '../helperFunctions/measurementSystem'

import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { dataWeeklyMileage, optionsWeeklyMileage, dataWeeklyMileageRoll } from "../variables/chartsData";


class Analytics extends React.Component {
  state = {
    sliderValue:[0,100],
    timeframe:'month',
    graphType:'Linear',
    activity:'Run',
    value:'Distance',
  }
  changeRange = (value) =>{
    clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(()=>{
        this.setState({sliderValue:value})
    }, 500);
  }
  render() {
    if(!Array.isArray(this.props.activities.entries)){
      return(<div></div>)
    }
    //const loca  = localStorage.getItem('user')
    const activitiesSorted = this.props.activities.entries.sort((a, b) =>new Date(a.date) -new Date(b.date));
    const measurementSystem = this.props.auth.measurementSystem
    const chartColor = "#1ebfe8";
    const gradientFill = 'rgba(255, 255, 200, 0.7)';
    var activities = filter_activities(activitiesSorted,this.state.activity)

    
    var [distance,dates] = distanceList(activities)
    distance = distance.map(dist => metricDistanceAnalytics(dist,measurementSystem))
    //console.log(distance)
    const [resampledDates, resampledDistance] = resampleDistance(dates,distance,this.state.timeframe)
    const max = Math.max.apply(null, distance) 
    const dataDistance = dataWeeklyMileage(resampledDates,resampledDistance,chartColor,gradientFill,this.state.sliderValue,metric(this.props.auth.measurementSystem),"Distance")
    const optionsDistance = optionsWeeklyMileage(parseInt(max))
    
    
    var data_show = dataDistance
    var options_show = optionsDistance
    //console.log(distance)
    
    for (var i=0;i<activities.length;i++){
      console.log(activities[i].distance)
      console.log(activities[i].duration)
    }
    
    if (this.state.value === "Duration"){
      var [duration,dates] = durationList(activities)
      var [resampledDates2, resampledDuration] = resampleDuration(dates,duration,this.state.timeframe)
      
      var dataDuration = dataWeeklyMileage(resampledDates2,resampledDuration,chartColor,gradientFill,this.state.sliderValue,metric(this.props.auth.measurementSystem),"Duration")
      var optionsDuration = optionsWeeklyMileage()
    
      data_show = dataDuration
      options_show = optionsDuration
    }
    var [distanceWeek,distanceMonth,distanceYear] = distanceSum(activities)
    var [durationWeek,durationMonth,durationYear] = durationSum(activities)
    distanceMonth = metricDistance(distanceMonth,measurementSystem)
    distanceWeek = metricDistance(distanceWeek,measurementSystem)
    distanceYear = metricDistance(distanceYear,measurementSystem)

    ///Rolling///
    const rollingDur = rollingduration(dates,duration,this.state.activity)
    const rollingDist = rollingDistance(dates,distance,this.state.activity)
    const dataRollingDur = dataWeeklyMileageRoll(dates,rollingDur,chartColor,gradientFill,this.state.sliderValue,metric(this.props.auth.measurementSystem),this.state.value)
    const dataRolling = dataWeeklyMileageRoll(dates,rollingDist,chartColor,gradientFill,this.state.sliderValue,metric(this.props.auth.measurementSystem),this.state.value)
    //const optionsRoll = optionsWeeklyMileageRoll(parseInt(max))
    return (
      <>{this.state.graphType === 'Linear' ? <PanelHeader
          size="lg"
          content={
            <Bar
              data={data_show}
              options={options_show}
            />
          }
        /> : ''}

        {this.state.graphType === 'Rolling' && this.state.value === 'Distance' ? 
           
          <PanelHeader
            size="lg"
            content={
              <Line
                data={dataRolling}
                options={options_show}
              />
            }
        /> : ''}
        {this.state.graphType === 'Rolling' && this.state.value === 'Duration' ? 
           
           <PanelHeader
             size="lg"
             content={
               <Line
                 data={dataRollingDur}
                 options={options_show}
               />
             }
         /> : ''}
        
        <div className="content">
        <Range min={0} max={100} defaultValue={this.state.sliderValue} step={4} onChange={this.changeRange}/>
        <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
        </Row>
        <Row>
            <Col xs={12} md={3}>
                <FormGroup>
                  <Input className='text-info' type="select" value={this.state.value} onChange={e => this.setState({value:e.target.value})}>
                    <option value ='Distance'>Distance</option>
                    <option value ='Duration'>Duration</option>
                  </Input>
                </FormGroup>
            </Col>
            <Col xs={12} md={3}>
                <FormGroup>
                  <Input className='text-info' type="select" value={this.state.activity} onChange={e => this.setState({activity:e.target.value})}>
                    <option value ='Run'>Run</option>
                    <option value ='Ride'>Ride</option>
                    <option value ='Swim'>Swim</option>
                    <option value ='All'>All</option>
                  </Input>
                </FormGroup>
            </Col>
            <Col xs={12} md={3}>
                <FormGroup>
                  <Input className='text-info' type="select" value={this.state.timeframe} onChange={e => this.setState({timeframe:e.target.value})}>
                    <option value ='week'>Week</option>
                    <option value ='month'>Month</option>
                    <option value ='year'>Year</option>
                  </Input>
                </FormGroup>
            </Col>
            <Col xs={12} md={3}>
                <FormGroup>
                  <Input className='text-info' type="select" value={this.state.graphType} onChange={e => this.setState({graphType:e.target.value})}>
                    <option value ='Linear'>Linear</option>
                    <option value ='Rolling'>Rolling (4 weeks)</option>
                  </Input>
                </FormGroup>
            </Col>
            
          </Row>
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category">Last 12 Months</h5>
                  <CardTitle tag="h4">{this.state.value === 'Distance' ? parseFloat(distanceYear).toFixed(2) :parseFloat(durationYear).toFixed(2)} <span style={{color:'rgb(200,180,255)',fontSize:'15px'}}>{this.state.value === 'Distance' ? metric(measurementSystem) : 'Hours'}</span></CardTitle>
                </CardHeader>
                
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> ---
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category">Last 30 days</h5>
                  <CardTitle tag="h4">{this.state.value === 'Distance' ? parseFloat(distanceMonth).toFixed(2) : parseFloat(durationMonth).toFixed(2)} <span style={{color:'rgb(200,180,255)',fontSize:'15px'}}>{this.state.value === 'Distance' ? metric(measurementSystem): 'Hours'}</span></CardTitle>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> ---
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category">Last 7 days</h5>
                  <CardTitle tag="h4">{this.state.value === 'Distance' ? parseFloat(distanceWeek).toFixed(2) : parseFloat(durationWeek).toFixed(2)} <span style={{color:'rgb(200,180,255)',fontSize:'15px'}}>{this.state.value === 'Distance' ? metric(measurementSystem) : 'Hours'}</span></CardTitle>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> ---
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {activities:state.activities,auth:state.auth}
}

export default connect(mapStateToProps)(Analytics);
